<script>
import fetcherCacheLoader from '@/mixins/fetcher/loaders/admin/cache-loader';
import spawnerCacheLoader from '@/mixins/spawner/loaders/admin/cache-loader';
// import crawlerCacheLoader from '@/mixins/crawler/loaders/admin/cache-loader';
// import monitorCacheLoader from '@/mixins/monitor/loaders/admin/cache-loader';

export default {
  mixins: [
    fetcherCacheLoader, //
    spawnerCacheLoader,
    // crawlerCacheLoader,
    // monitorCacheLoader,
  ],
  template: '<div></div>',
};
</script>
